import React from 'react';
import PropTypes from 'prop-types';
import { isPresent } from 'utils/helperMethods';
import { useTranslation } from 'react-i18next';

import useScreen from 'hooks/useScreen';
import emoji from 'emoji-dictionary';
import Avatar from 'sharedComponents/Avatar';
import Tag from 'sharedComponents/Tag';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import LoanOfficerPresenter from 'presenters/LoanOfficerPresenter';

import { Typography } from '@material-ui/core';

import useStyles from './useStyles';

const LoanOfficerCard = props => {
  const { loanOfficer, onSelect } = props;
  const classes = useStyles();
  const { isDesktop } = useScreen();
  const { t } = useTranslation();

  const tags = [
    {
      Component: (
        <Typography noWrap variant="subtitle1" color="inherit" className={classes.label}>
          {t(
            'components.BuyerLoanOfficerSearchSurvey.LoanOfficerSelect.LoanOfficersList.LoanOfficerCard.fastResponder',
          )}
        </Typography>
      ),
      color: 'green',
      key: 1,
    },
    {
      Component: (
        <Typography noWrap variant="subtitle1" color="inherit" className={classes.label}>
          {t('components.BuyerLoanOfficerSearchSurvey.LoanOfficerSelect.LoanOfficersList.LoanOfficerCard.lowRates')}
        </Typography>
      ),
      color: 'red',
      key: 2,
    },
    {
      Component: (
        <Typography noWrap variant="subtitle1" color="inherit" className={classes.label}>
          {t('components.BuyerLoanOfficerSearchSurvey.LoanOfficerSelect.LoanOfficersList.LoanOfficerCard.fastClosing')}
        </Typography>
      ),
      color: 'blue',
      key: 3,
    },
  ];

  const isCompanyLogotypePresent = isPresent(LoanOfficerPresenter.companyLogoUrl(loanOfficer));

  const handleSelect = () => {
    onSelect(loanOfficer);
  };

  const responseRate = LoanOfficerPresenter.responseRate(loanOfficer);
  const isResponseRatePresent = isPresent(responseRate);
  const totalBidRequestsCount = LoanOfficerPresenter.totalBidRequestsCount(loanOfficer);
  const shouldShowHelpedBadge = totalBidRequestsCount !== 0;
  const shuffledTags = tags.sort(() => Math.random() - 0.5);

  return (
    <div className={classes.container} onClick={handleSelect} role="presentation">
      <div className={classes.mainBox}>
        <div className={classes.avatarBox}>
          <Avatar size="l" imageUrl={LoanOfficerPresenter.profileImageUrl(loanOfficer)} />
        </div>
        <div className={classes.detailsBox}>
          <div className={classes.loanOfficerBadge}>
            <Typography noWrap variant="h3" className={classes.name}>
              {LoanOfficerPresenter.fullName(loanOfficer)}{' '}
              {isResponseRatePresent && (
                <span className={classes.responseBadge}>
                  <ThumbUpIcon style={{ fontSize: 14 }} className={classes.thumbIcon} />
                  {`${responseRate} %`}
                </span>
              )}
            </Typography>

            <Typography variant="subtitle1" color="secondary">
              {t('components.BuyerLoanOfficerSearchSurvey.LoanOfficerSelect.LoanOfficersList.LoanOfficerCard.nmls', {
                nmls: LoanOfficerPresenter.nmls(loanOfficer),
              })}
            </Typography>
            <Typography noWrap variant="subtitle1" color="secondary">
              {LoanOfficerPresenter.companyName(loanOfficer)}
            </Typography>
          </div>
          <div className={classes.tips}>
            <div className={classes.badgesBox}>
              {shouldShowHelpedBadge && (
                <div className={classes.helpedBadge}>
                  {emoji.getUnicode('woman_mechanic')}
                  <Typography
                    variant="subtitle1"
                    className={classes.helpLabel}
                    dangerouslySetInnerHTML={{
                      __html: t(
                        'components.BuyerLoanOfficerSearchSurvey.LoanOfficerSelect.LoanOfficersList.LoanOfficerCard.helpedBadgeText',
                        { helpedCount: totalBidRequestsCount },
                      ),
                    }}
                  />
                </div>
              )}
            </div>
            <div className={classes.tagsBox}>
              {shuffledTags.map(({ key, Component, color }) => (
                <Tag key={key} color={color} className={classes.tag}>
                  {Component}
                </Tag>
              ))}
            </div>
          </div>
          {isDesktop && (
            <div className={classes.companyLogoBox}>
              {isCompanyLogotypePresent && (
                <img
                  alt="company logo"
                  src={LoanOfficerPresenter.companyLogoUrl(loanOfficer)}
                  className={classes.companyLogo}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

LoanOfficerCard.propTypes = {
  loanOfficer: LoanOfficerPresenter.shape().isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default LoanOfficerCard;



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/LoanOfficerSelect/components/LoanOfficersList/components/LoanOfficerCard/LoanOfficerCard.js